import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {DeviceControlComponent} from './device-control.component';

@NgModule({
    imports: [
        PagesSharedModule
    ],
    declarations: [
        DeviceControlComponent
    ],
    entryComponents: [],
    exports: [
        DeviceControlComponent
    ]
})
export class DeviceControlModule {
}
